import React, { useState } from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

type Data = {
  id: number;
  name: string;
  component: React.FC;
};
interface TabListProps extends RouteComponentProps {
  data: Data[];
}

const TabList: React.FC<TabListProps> = ({ data, history }) => {
  const [selectedTab, setSelectedTab] = useState(1);

  const handleNextTab = (e: any) => {
    if (selectedTab < data.length) {
      setSelectedTab(selectedTab + 1);
      e.target.nextSibling.focus();
      history.push(`/${parseInt(e.currentTarget.id) + 1}`);
    }
  };

  const handleBackTab = (e: any) => {
    if (selectedTab > 1) {
      setSelectedTab(selectedTab - 1);
      e.currentTarget.previousSibling.focus();
      history.push(`/${parseInt(e.currentTarget.id) - 1}`);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'ArrowRight') {
      handleNextTab(e);
    }
    if (e.key === 'ArrowLeft') {
      handleBackTab(e);
    }
  };

  const handleClick = (e: any) => {
    setSelectedTab(parseInt(e.currentTarget.getAttribute('id')));
  };

  return (
    <div role="tablist" className="ads-tabs" data-testid="ads-tabs">
      {data.map(({ id, name }) => (
        <Link
          role="tab"
          className={`ads-tabs__tab ${
            selectedTab === id && 'ads-tabs__tab--selected '
          }`}
          key={id}
          tabIndex={selectedTab === id ? 0 : -1}
          aria-controls={name}
          aria-selected={selectedTab === id}
          id={`${id}`}
          to={`/${id}`}
          onKeyDown={(e) => handleKeyDown(e)}
          onClick={(e) => handleClick(e)}
        >
          {name}
        </Link>
      ))}
    </div>
  );
};

export default withRouter(TabList);
